import React from 'react';

const LOGO_URL = process.env.REACT_APP_LOGO_URL || "https://customer-assets.emergentagent.com/job_clone-portal-11/artifacts/zqz7dv66_6CF62CF6-C98D-4DC4-91E4-C2649D47B807-removebg-preview.png";

const HeroSection = () => {
  return (
    <section className="relative w-full overflow-hidden bg-[#f5f3ef] pt-16 md:pt-20" data-testid="hero-section">
      <div className="relative z-10 flex flex-col items-center px-6 text-center">
        {/* Logo Image */}
        <img 
          src={LOGO_URL} 
          alt="The First Dance by Bogi"
          className="w-64 md:w-80 lg:w-96 h-auto"
          style={{ filter: 'brightness(0.4)' }}
          data-testid="hero-logo"
        />

        {/* Faint decorative line under logo */}
        <div 
          className="-mt-4 md:-mt-6 w-32 md:w-48 h-px bg-[#5a6b4e]/30"
          data-testid="hero-divider"
        />
      </div>
    </section>
  );
};

export default HeroSection;
